import VerifyForm from '../components/auth/VerifyForm';
import { useSearchParams } from 'react-router-dom';
import useVerifyEmail from '../hooks/useVerifyEmail';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import { useAuth } from '../context/AuthContext';

function VerifySection() {
  const { refetchUser } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const initialToken = searchParams.get('token') || '';
  const {
    mutate: verifyEmailRequest,
    isLoading: isLoadingVerifyEmail,
    error: verifyEmailError,
  } = useVerifyEmail();

  if (verifyEmailError) {
    toast({
      title: 'Verify',
      description: verifyEmailError?.toString() || 'Verification failed',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  }

  const onEmailVerify = (token) =>
    verifyEmailRequest(token, {
      onSuccess: (data) => {
        if (data && data.user) {
          refetchUser();
          navigate('/');
        }
      },
    });

  return (
    <VerifyForm
      initialToken={initialToken}
      isLoading={isLoadingVerifyEmail}
      onSubmit={onEmailVerify}
    />
  );
}

export default VerifySection;
